module.exports = __webpack_public_path__ + "img/horizontal_4_7_pp3_9016.6938385f.png";